var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action",class:_vm.className,attrs:{"title":_vm.title}},[_c(_vm.icon,{tag:"component",staticClass:"icon",on:{"click":function($event){$event.preventDefault();return _vm.action()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }